import React from 'react';
import { Typography } from '@mui/material';
import {
	linkObject,
	getDetailLink,
	toSimpleLink,
} from '../../../lib/helpers/index';
import { linkCustomer } from '../helpers';
import rpcShared from '@rockpapercoin/rpc-shared';
import { LinkObjectType } from '../../../lib/helpers/types';

export default function quickPaymentPaidEventProps(
	defaultEventProps: {
		event: any;
		message: React.JSX.Element;
		links: {
			type: string;
			text: string;
			link: any;
			onClick?: ( () => any ) | null;
		}[];
		icon: string;
		className: string;
	},
	user: any
) {
	const updatedEventProps = { ...defaultEventProps };
	const { event } = updatedEventProps;

	const quickPaymentLink = toSimpleLink( {
		link: getDetailLink( { object: event.invoice } ),
		text: 'quick payment',
	} );

	const vendorOBOLink = toSimpleLink( {
		link: getDetailLink( {
			object: event.vendor,
			type: LinkObjectType.Organization,
			params: { client: event.contact.customer.clientUser?.id },
		} ),
		text: event.vendor.name,
	} );

	const customerLink = linkCustomer( event );
	const vendorLink = linkObject( event.vendor );

	updatedEventProps.icon = 'invoice';

	updatedEventProps.links = [
		{
			type: 'secondary',
			text: 'View',
			link: getDetailLink( {
				object: updatedEventProps.event.invoice,
				type: LinkObjectType.Invoice,
			} ),
		},
	];

	if (
		rpcShared.contacts.isAssignedPlannerOrAdminOfCustomersPlannerOrg(
			defaultEventProps.event.contact,
			user
		)
	) {
		updatedEventProps.message = (
			<Typography className='p--secondary'>
				{ customerLink } paid a { quickPaymentLink } to { vendorOBOLink }.
			</Typography>
		);
	}

	if (
		rpcShared.contacts.isMemberOfVendor( defaultEventProps.event.contact, user )
	) {
		updatedEventProps.message = (
			<Typography className='p--secondary'>
				{ customerLink } sent you a { quickPaymentLink }.
			</Typography>
		);
	}

	if (
		rpcShared.contacts.isCustomer( defaultEventProps.event.contact, user.user.id )
	) {
		updatedEventProps.message = (
			<Typography className='p--secondary'>
				You paid a { quickPaymentLink } to { vendorLink }.
			</Typography>
		);
	}

	return updatedEventProps;
}
